import { ScopeTag } from "./ScopeTag";

export enum EstimateType {
	MITIGATION = "MITIGATION",
	RECONSTRUCTION = "RECONSTRUCTION",
	CONTENTS = "CONTENTS",
	MOLD = "MOLD",
	FIRE_MITIGATION = "FIRE_MITIGATION",
	BIOHAZARD = "BIOHAZARD",
	TIME_AND_MATERIAL = "TIME_AND_MATERIAL",
}

/**
 * Maps an EstimateType to its required ScopeTags
 */
export function getRequiredScopesForEstimateType(estimateType: EstimateType): ScopeTag[] {
	switch (estimateType) {
		case EstimateType.RECONSTRUCTION:
			return [ScopeTag.INTERIOR_RECONSTRUCTION, ScopeTag.EXTERIOR_RECONSTRUCTION];
		case EstimateType.MITIGATION:
			return [ScopeTag.WATER_MITIGATION];
		case EstimateType.CONTENTS:
			return [ScopeTag.CONTENTS];
		case EstimateType.MOLD:
			return [ScopeTag.MOLD];
		case EstimateType.FIRE_MITIGATION:
			return [ScopeTag.FIRE_MITIGATION];
		case EstimateType.BIOHAZARD:
			return [ScopeTag.BIOHAZARD];
		case EstimateType.TIME_AND_MATERIAL:
			return [ScopeTag.TIME_AND_MATERIAL];
		default:
			return [];
	}
}
